import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useMatch, useLocation, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import App1 from "./App1";
import Admin from "./AppAdmin";
import AppManage from "./AppManage";
import AppPublic from "./AppPublic";
import "./MainApp.css";
import "./styles/theme.css";
import "./styles/BottomNav.css";
import "./styles/Header.css";
import LoginPage from "./LoginPage";
import { clearSharedExpenseCache } from "./service/sharedExpenseStore";

const MainApp = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(JSON.parse(localStorage.getItem("isLoggedOut")));
  const [error, setError] = useState(false);

  const matchApp1 = useMatch("/app1/*");
  const _admin = useMatch("/admin/*");
  const matchApp3 = useMatch("/manage/*");
  const matchApp4 = useMatch("/public/*");

  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    try {
      const isExplicitlyLoggedOut = localStorage.getItem("isLoggedOut") === "true";
      if (isExplicitlyLoggedOut) {
        setIsLoggedIn(false);
        setIsLoggedOut(true);
        setError(false);
        return;
      }

      const guestUser = JSON.parse(localStorage.getItem("guestUser"));
      if (guestUser && guestUser.email === "guest") {
        // Active guest session (explicitly started by tapping Continue as Guest)
        localStorage.setItem("loggedInUserEmail", "guest");
        localStorage.removeItem("loggedInUser");
        setIsLoggedIn(true);
        setIsLoggedOut(false);
        setError(false);
        return;
      }

      const sessionUser = JSON.parse(localStorage.getItem("loggedInUser"));
      const isRealUser = sessionUser && sessionUser.email && sessionUser.email !== "guest" && sessionUser.email.includes("@");

      if (isRealUser) {
        // Active real user verified
        localStorage.setItem("loggedInUserEmail", sessionUser.email);
        localStorage.removeItem("guestUser");
        setError(false);
        setIsLoggedIn(true);
        setIsLoggedOut(false);
        return;
      }

      // No active session: show login screen
      setIsLoggedIn(false);
      setIsLoggedOut(false);
      setError(false);
    } catch {
      setError(true);
    }
  }, []); // reads localStorage once on mount; handleLogin updates the state directly

  useEffect(() => {
    if (location.pathname !== "/" && !matchApp4) {
      localStorage.setItem("lastVisitedPage", location.pathname + location.search);
    }
  }, [location, matchApp4]);

  const isNestedApp = matchApp1 || matchApp3 || matchApp4 || _admin;

  const handleLogin = (userData) => {
    try {
      if (userData.email === "guest") {
        // Clear previous user session & shared expense cache from old user
        localStorage.removeItem("loggedInUser");
        localStorage.removeItem("pocketapp_sessionUser");
        clearSharedExpenseCache();

        // Establish clean guest session without touching guest expense or todo data
        localStorage.setItem("guestUser", JSON.stringify(userData));
        localStorage.setItem("loggedInUserEmail", "guest");
        localStorage.setItem("isLoggedOut", "false");
      } else {
        localStorage.setItem("loggedInUser", JSON.stringify(userData));
        localStorage.setItem("loggedInUserEmail", userData.email);
        localStorage.setItem("rememberedEmail", userData.email);
        localStorage.setItem("biometricEnabled", "true");
        localStorage.setItem("hasLoggedInOnce", "true");
        localStorage.setItem("isLoggedOut", "false");
        localStorage.removeItem("guestUser");
      }
      setIsLoggedOut(false);
      setIsLoggedIn(userData);
      setError(false);
      const lastPage = localStorage.getItem("lastVisitedPage");
      navigate(lastPage || "/app1/home", { replace: true });
      return;
    } catch {
      setError(true);
    }
  };

  if ((!isLoggedIn || isLoggedOut) && !matchApp4) {
    return <LoginPage onLogin={handleLogin} />;
  }
  const NotFoundPage = () => {
    return (
      <div className="container" style={{ textAlign: "center", padding: "20px" }}>
        <h1>Welcome to Pocket Apps</h1>

        <p>Please reload the App</p>
        <button className="btn btn-success" onClick={() => (window.location.href = "/")} style={{ padding: "10px 30px", fontSize: "16px" }}>
          Reload
        </button>
      </div>
    );
  };
  return (
    <>
      {error ? (
        <NotFoundPage />
      ) : (
        <div>
          {!isNestedApp && <Navigate to={localStorage.getItem("lastVisitedPage") || "/app1/home"} replace />}
          <ErrorBoundary>
            <Routes>
              <Route path="/app1/*" element={<App1 />} />
              {/* removed or merged apps: old saved links go to Expense Tracker */}
              <Route path="/app4/*" element={<Navigate to="/app1/todo" replace />} />
              <Route path="/app5/*" element={<Navigate to="/app1/home" replace />} />
              <Route path="/app6/*" element={<Navigate to="/app1/home" replace />} />

              <Route path="/manage/*" element={<AppManage />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="/public/*" element={<AppPublic />} />
              {/* <Route path="/*" element={<NotFoundPage />} /> */}
            </Routes>
          </ErrorBoundary>

        </div>
      )}
    </>
  );
};

// Wrap MainApp with Router to allow useMatch and other hooks to work
const MainAppWrapper = () => (
  <Router>
    <MainApp />
  </Router>
);


export default MainAppWrapper;
